import React from 'react';
import { DiscoverEventCardProps } from './types';

import loadable from '@loadable/component';
import {
    BrowseCardHierarchyExperimentValues,
    UrgencySignalEventCardExperimentValues,
} from '../../types';

//To prevent content flash during loadable fetch of module, importing

type EventCardMobileImportMap = Record<
    UrgencySignalEventCardExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

type EventCardDesktopImportMap = Record<
    UrgencySignalEventCardExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

type BrowseCardDesktopImportMap = Record<
    BrowseCardHierarchyExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

export const EXPERIMENT_SEARCH_CARD_MAP_MOBILE: EventCardMobileImportMap = {
    [UrgencySignalEventCardExperimentValues.control]: loadable(
        () => import('./Vertical/DiscoverVerticalSearchEventCard'),
    ),
    [UrgencySignalEventCardExperimentValues.variantA]: loadable(
        () =>
            import('./Vertical/DiscoverVerticalSearchEventCardUrgencySignalA'),
    ),
    [UrgencySignalEventCardExperimentValues.variantB]: loadable(
        () =>
            import('./Vertical/DiscoverVerticalSearchEventCardUrgencySignalB'),
    ),
};

export const EXPERIMENT_SEARCH_CARD_MAP_DESKTOP: EventCardDesktopImportMap = {
    [UrgencySignalEventCardExperimentValues.control]: loadable(
        () => import('./Horizontal/DiscoverHorizontalEventCard'),
    ),
    [UrgencySignalEventCardExperimentValues.variantA]: loadable(
        () => import('./Horizontal/DiscoverHorizontalEventCardUrgencySignalA'),
    ),
    [UrgencySignalEventCardExperimentValues.variantB]: loadable(
        () => import('./Horizontal/DiscoverHorizontalEventCardUrgencySignalB'),
    ),
};

export const EXPERIMENT_BROWSE_CARD_MAP_DESKTOP: BrowseCardDesktopImportMap = {
    [BrowseCardHierarchyExperimentValues.control]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseEventCard'),
    ),
    [BrowseCardHierarchyExperimentValues.hierarchy]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseHierarchyEventCard'),
    ),
};

export type { DiscoverEventCardProps };
